import { useMatches } from 'react-router-dom';
import { useEffect } from 'react';
import { createURLSearchParamsHelper } from '@m2h/common/utils/urlSearchParamsHelper';
import { getRealTimeMachConf } from '@m2h/common/Mach/machproH5Base/base-h5';
import {
  mergeMachConfig2Window,
  extractSearchParams,
  storeMachObject,
  setMachEnv,
  setSchemeParams,
} from '@m2h/common/utils/machUtils';
import { initWorker } from '@m2h/shared_worker_global';

// 优先级： 1.实时计算值 > 2.url参数转化值 > 3.页面入口自定义初始化值 > 4.缓存值
// 优先级：2.优化后的 useSearchParamsInit 函数
export const useSearchParamsInit = (
  searchParamsInput: SearchParamsInput,
  keyToValues: KeyToValueItem[]
): void => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    // console.log('bundleName useSearchParamsInit useEffect');
    // 离开组件页面时，清除数据： Mach.data 和 Mach.env.schemeParams
    return () => {
      // clearStoredPageMach();
    };
  }, []);
  initWorker();

  const location = window.location;
  console.log('bundleName 优先级2 useSearchParamsInit start', window.Mach.env);

  // 找到当前路由的 handle
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const matches = useMatches() || [];
  // const currentMatch = (matches[matches.length - 1] || {}) as VRouterHandle;
  const currentMatch = matches[matches.length - 1];
  const {
    bundleName,
    bundleVersion,
  } = (currentMatch?.handle || {}) as VRouterHandle;
  setMachEnv('bundleName', bundleName);
  setMachEnv('bundleVersion', bundleVersion);

  try {
    const locationSearchParams = new URLSearchParams(location.search);
    const searchParams = extractSearchParams(searchParamsInput);
    // @ts-ignore
    if (searchParams && searchParams.size > 0) {
      // 参数默认映射处理
      // locationSearchParams.entries().forEach(key => console.log(key));

      const locationSearchParams1 = createURLSearchParamsHelper(locationSearchParams);
      const searchParams1 = createURLSearchParamsHelper(searchParams);

      locationSearchParams1.forEach((value, key, urlObj) => {
        console.log(key, ':', value);
        setSchemeParams(key, value);
      });

      searchParams1.forEach((value, key, urlObj) => {
        // console.log(key, ':', value);
        setSchemeParams(key, value);
      });

      // keyToValues自定以的参数映射
      if (keyToValues?.length) {
        keyToValues.forEach(({ key, method }) => {
          if (!key || typeof method !== 'function') {
            console.warn('Invalid keyToValues item:', { key, method });
            return;
          }
          // 优先从query参数获取，再从路由参数获取
          const value = locationSearchParams.get(key) || searchParams.get(key);
          if (value !== null && value !== '') {
            method(key, value);
          }
        });
      }
    }
  } catch (error) {
    console.error('Error processing search params:', error);
  }
  // 优先级： 1.实时计算值 > 2.url参数转化值 > 3.页面入口自定义初始化值 > 4.缓存值
  // 优先级：1.实时计算值 合入/统一写入新的mach缓存值
  console.log('bundleName 优先级1 useSearchParamsInit', window.Mach.env);
  mergeMachConfig2Window(getRealTimeMachConf(), true, true); // 更新即存？
};

export default useSearchParamsInit;
